/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigMatrixValueValue } from './ConfigMatrixValueValue';
import {
    ConfigMatrixValueValueFromJSON,
    ConfigMatrixValueValueFromJSONTyped,
    ConfigMatrixValueValueToJSON,
    ConfigMatrixValueValueToJSONTyped,
} from './ConfigMatrixValueValue';

/**
 * 
 * @export
 * @interface ConfigMatrixValue
 */
export interface ConfigMatrixValue {
    /**
     * Office key, use '*' as wildcard for all offices
     * @type {string}
     * @memberof ConfigMatrixValue
     */
    officeKey?: string;
    /**
     * LoB key, use '*' as wildcard for all LoBs
     * @type {string}
     * @memberof ConfigMatrixValue
     */
    lobKey?: string;
    /**
     * 
     * @type {ConfigMatrixValueValue}
     * @memberof ConfigMatrixValue
     */
    value?: ConfigMatrixValueValue;
}

/**
 * Check if a given object implements the ConfigMatrixValue interface.
 */
export function instanceOfConfigMatrixValue(value: object): value is ConfigMatrixValue {
    return true;
}

export function ConfigMatrixValueFromJSON(json: any): ConfigMatrixValue {
    return ConfigMatrixValueFromJSONTyped(json, false);
}

export function ConfigMatrixValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigMatrixValue {
    if (json == null) {
        return json;
    }
    return {
        
        'officeKey': json['officeKey'] == null ? undefined : json['officeKey'],
        'lobKey': json['lobKey'] == null ? undefined : json['lobKey'],
        'value': json['value'] == null ? undefined : ConfigMatrixValueValueFromJSON(json['value']),
    };
}

export function ConfigMatrixValueToJSON(json: any): ConfigMatrixValue {
    return ConfigMatrixValueToJSONTyped(json, false);
}

export function ConfigMatrixValueToJSONTyped(value?: ConfigMatrixValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'officeKey': value['officeKey'],
        'lobKey': value['lobKey'],
        'value': ConfigMatrixValueValueToJSON(value['value']),
    };
}

